export default {
  NOTIFICATION_DATA: 'NOTIFICATION_DATA',
  TOGGLE_NOTIFICATION: 'TOGGLE_NOTIFICATION',
}
